import { cn } from '../../lib/cn';

export interface SpinnerProps {
  className?: string;
  label?: string;
}

export function Spinner({ className, label }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current',
        'border-t-transparent',
        className,
      )}
      role={label ? 'status' : 'presentation'}
      aria-label={label}
    />
  );
}
